// extracted by mini-css-extract-plugin
export default {"virtualizedList":"VirtualizedList_virtualizedList__3S10W"};